import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { breakpoints } from '../../../theme';

export const LayoutContainer = styled(Grid)`
  width: 100%;
  display: flex;
  margin: 0;
  min-height: 100vh;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
  overflow: hidden;
`;

interface ContentDivProps {
  dashboard?: boolean;
}

export const ContentDiv = styled(Grid)<ContentDivProps>`
  position: relative;
  flex: 1;
  margin: 0 auto;
  width: 100%;
  max-width: 1216px;
  height: 100%;
  padding-bottom: 40px;

  ${({ theme }) => theme.breakpoints.down(breakpoints.desktop)} {
    padding: 0 24px 40px;
  }
`;
